import type { ComponentType } from 'react';
import type { Notification, NotificationPayload, NotificationType } from '../../../shared/types.js';
import { GenericMarkdownRenderer } from './GenericMarkdownRenderer';
import { PluginDisabledRenderer } from './PluginDisabledRenderer';
import { ReleaseEventRenderer } from './ReleaseEventRenderer';
import { VersionReleaseRenderer } from './VersionReleaseRenderer';

type Renderer<P extends NotificationPayload> = ComponentType<{ payload: P }>;

/**
 * Closed registry of per-type renderers. Adding a new payload variant means
 * registering its renderer here and appending to the Zod discriminated
 * union in `shared/types.ts`.
 */
const RENDERERS: { [K in NotificationType]: Renderer<Extract<NotificationPayload, { type: K }>> } =
  {
    generic_markdown: GenericMarkdownRenderer,
    version_release: VersionReleaseRenderer,
    release_event: ReleaseEventRenderer,
    plugin_disabled: PluginDisabledRenderer,
  };

export function NotificationBody({ notification }: { notification: Notification }) {
  const Renderer = RENDERERS[notification.type] as ComponentType<{
    payload: NotificationPayload;
  }>;
  return <Renderer payload={notification.payload} />;
}

export {
  GenericMarkdownRenderer,
  PluginDisabledRenderer,
  ReleaseEventRenderer,
  VersionReleaseRenderer,
};
